const styles = theme => ({
  logo: {
    width: '164px',
    height: 'auto',
    marginBottom: theme.spacing(3),
  },
  card: {
    overflow: 'hidden',
    position: 'relative',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    padding: theme.spacing(4),
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  successIcon: {
    fontSize: '60px',
    marginBottom: theme.spacing(1),
  },
  title: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(4),
  },
  subTitle: {
    marginBottom: theme.spacing(4),
  },
  fields: {
    marginBottom: theme.spacing(4),
  },
  button: {
    marginBottom: theme.spacing(2),
  },
  linkBack: {
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
  progress: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
  },
})

export default styles
